import Typography from '@mui/material/Typography';
import React, { useEffect } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import { Badge, CommunityGamificationService } from '../../../../services/restserver-openapi';
import { BadgesSkeleton } from './BadgesSkeleton';
import { formatAsSwissDate } from '../../../../utils/dateUtil';

interface UserBadgesProps {
    communityName: string;
    isCompactView: boolean;
}

const UserBadges: React.FC<UserBadgesProps> = ({ communityName, isCompactView = false }) => {
    const [badges, setBadges] = React.useState<Badge[] | null>(null);
    const [error, setError] = React.useState<string | null>(null);

    useEffect(() => {
        async function fetchBadges() {
            try {
                const response = await CommunityGamificationService.getBadges(communityName);
                if (response !== undefined) {
                    setError(null);
                    setBadges(response);
                }
                else {
                    setError("Fehler: Keine Daten vorhanden.");
                }
            } catch (error) {
                setError("Fehler: Auszeichnungen konnten nicht geladen werden");
            }
        }

        if (communityName) {
            fetchBadges();
        }
    }, [communityName]);

    useEffect(() => {
        if (!communityName) {
            setError("Fehler: Auszeichnungen konnten nicht geladen werden");
        }
    }, [communityName, badges]);

    function Badges(): React.ReactElement {
        if (error !== null) {
            return (
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography color={"error"}>
                                {error}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            );
        }

        if (badges === null) {
            // still loading
            return <BadgesSkeleton numberOfElements={6}/>;
        }

        if (badges.length === 0) {
            return (
                <Grid item>
                    <Typography>Noch keine Auszeichnungen.</Typography>
                </Grid>
            );
        }

        return (
            <>
                {badges.map((badge: Badge) => {
                    let image;
                    try {
                        image = require(`../../../../assets/Images/badges/${badge.id}.jpg`);
                    } catch (e) {
                        image = require(`../../../../assets/Images/badges/placeholder.jpg`);
                    }

                    const receivedAt = formatAsSwissDate(Number(badge.receivedAt));

                    return (
                        <Grid item xs={12} sm={6} md={isCompactView ? 6 : 4} key={badge.id} container justifyContent={"space-between"}>
                            <Grid item xs={12} container justifyContent="center">
                                <Card style={{ width: '100%' }}>
                                    <CardMedia
                                        component="img"
                                        image={image}
                                        style={{
                                            display: 'block',
                                            margin: 'auto',
                                            maxWidth: '200px',
                                            maxHeight: '200px',
                                            boxSizing: 'border-box',
                                            borderRadius: '100%',
                                            padding: '16px',
                                        }}
                                    />
                                    <CardContent style={{paddingTop: 0}}>
                                        <Typography variant="h6" style={{ overflowWrap: 'break-word'}}>{badge.title}</Typography>
                                        <Typography variant="body1">{badge.description}</Typography>
                                        <Typography variant="subtitle2" sx={{ mt: 1 }}>Erhalten am: {receivedAt}</Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    );
                })}
            </>
        );
    }

    return (
        <Grid container spacing={2}>
            <Badges />
        </Grid>
    )
}

export default UserBadges;
